<ng-container *ngIf="isComponent; else displayData">
</ng-container>
<ng-template #displayData>
    {{ associatedData }}
</ng-template>
